define('languages/fi_FI',[],function () {
  'use strict';
  return {
    // MENU
    'menu.home': 'Etusivu',
    'menu.overview': 'Yleiskatsaus',
    'menu.weekly_offers': 'Keskitetyt kampanjat',
    'menu.my_media': 'Oma mediakirjasto',
    'menu.my_ads': 'Omat kampanjat ja pohjat',
    'menu.content_recommendations': 'Suositellut sisällöt',
    'menu.settings': 'Asetukset',
    'menu.help': 'Ohjeet',
    'menu.logout': 'Kirjaudu ulos',

    // SIVAKOHDAT
    'page_titles.home': 'Etusivu',
    'page_titles.news': 'Uutiset',
    'page_titles.edit_news_item': 'Muokkaa uutisia',
    'page_titles.overview': 'Yhteenveto',
    'page_titles.weekly_offers': 'Keskitetyt kampanjat',
    'page_titles.content': 'Sisältö',
    'page_titles.my_media': 'Oma mediakirjasto',
    'page_titles.my_ads': 'Omat kampanjat ja pohjat',
    'page_titles.select_template': 'Valitse kampanjapohja',
    'page_titles.create_ad': 'Luo kampanja',
    'page_titles.edit_ad': 'Muokkaa kampanjaa',
    'page_titles.settings': 'Asetukset',
    'page_titles.templates': 'Kampanjapohjat',
    'page_titles.campaigns': 'Keskitetyt kampanjat',
    'page_titles.content_recommendations': 'Suositellut sisällöt',
    'page_titles.help': 'Ohjeet',
    'page_titles.logout': 'Kirjaudu ulos',

    // HEADER
    'header.app_name': 'K-Media',
    'header.menu': 'Valikko',
    'header.overview': 'Yhteenveto',
    'header.select_store_modal.switch_store': 'Vaihda kauppa?',
    'header.select_store_modal.select_store': 'Valitse kauppa',
    'header.select_store_modal.switch': 'Vaihda',

    // FOOTER
    'footer.text':
      'Tuki: <a href="mailto:digitaalisetpalvelut@kesko.fi"> digitaalisetpalvelut@kesko.fi </a>',

    // LOGIN
    'login.label.username': 'Käyttäjätunnus',
    'login.label.password': 'Salasana',
    'login.label.email': 'Sähköpostiosoite',
    'login.placeholder.username': 'name@company.com',
    'login.placeholder.password': '●●●●●',
    'login.placeholder.email': 'name@company.com',
    'login.button.login': 'Kirjaudu',
    'oidclogin.button.login': 'Kirjaudu pitkällä K-käyttäjätunnuksella',
    'login.button.reset': 'Palauta',
    'login.link.login': 'Kirjaudu',
    'login.link.forgot_password': 'Unohditko salasanasi?',
    'login.text.forgot_password':
      '<p> Jos olet unohtanut salasanasi, kirjoita sähköpostiosoitteesi alle ja paina "Palauta". </p> <p> Lähetämme sinulle linkin, jonka avulla voit vaihtaa salasanasi. </p> ',
    'login.text.password_reset':
      '<p> Osoitteeseesi on lähetetty linkki. Noudata viestin ohjeita palauttaaksesi salasanasi. </p> ',
    'login.text.login_error':
      'Jokin meni pieleen, tarkista nimesi ja salasanasi ja yritä uudelleen.',
    'login.auth_error.header':
      'Sinulla ei ole oikeuksia K Diginäytöt -järjestelmään.',
    'login.auth_error.text1':
      'Kirjautuminen K-Diginäytöt - järjestelmään tapahtuu Keskon käyttäjätunnuksilla.',
    'login.auth_error.text2':
      'Oikeudet järjestelmän käyttäjille tilataan K-käyttöoikeudet -sovelluksesta.',
    'login.auth_error.text3':
      'Käyttöoikeudet aktivoituvat noin 30 minuutin kuluttua tilauksesta.',
    'login.auth_error.text4': 'KCM KT Käyttöoikeudet',
    'login.auth_error.text5':
      'Käyttöoikeustilaukset esihenkilön toimesta osoitteesta: kcmktkayttooikeustilaukset@kesko.fi',
    'login.auth_error.text6':
      'Poikkeavasta käyttöoikeuden tilauksesta tulee olla myös perustelut.',

    // CHANGE PASSWORD
    'change_password.header.change_password': 'Vaihda salasana',
    'change_password.label.old_password': 'Vanha salasana',
    'change_password.label.new_password': 'Uusi salasana',
    'change_password.button.send': 'Lähetä',
    'change_password.error': 'Sinun on annettava vanha ja uusi salasanasi',
    'change_password.success': 'Salasanasi on vaihdettu!',

    // HOME
    'home.link.edit_news': 'Muokkaa uutisia',

    // NEWS
    'news.header.title': 'Uutiset',
    'news.header.start_date': 'Julkaisupäivä',
    'news.header.end_date': 'Päättymispäivä',
    'news.header.pinned': 'Kiinnitetty',
    'news.header.profiles': 'Ketju',
    'news.header.edit': 'Muokkaa',
    'news.header.delete': 'Poista',
    'news.label.header': 'Otsikko',
    'news.label.date': 'Julkaisupäivä',
    'news.label.end_date': 'Päättymispäivä',
    'news.label.text': 'Teksti',
    'news.button.add_news_item': 'Lisää uutinen',
    'news.button.save': 'Tallenna',
    'news.button.edit': 'Muokkaa',
    'news.button.remove': 'Poista',
    'news.button.remove.confirm': 'Poista?',

    // NEWSFORM
    'newsform.button.save': 'Tallenna uutinen',
    'newsform.feedback.news_item_saved': 'Uutiset tallennettu!',

    // OVERVIEW
    'overview.intro.heading': 'Näytöt/mediasoittimet',
    'overview.intro.text':
      'Klikkaa haluamaasi alla olevaa näyttöä nähdäksesi tai muokataksesi sisältöä. Näytön jäljellä oleva sekuntimäärä päivittyy uuden kampanjan lisäämisen jälkeen vasta kun tämä sivu ladataan uudestaan. Voit esikatsella näytöillä olevia kampanjoita klikkaamalla esikatsele-nappia oikeanpuoleisimmassa sarakkeessa. Jos kuitenkin haluat saada kokonaiskuvan kaikista kampanjoista näytöllä klikkaa näyttöjä ja tarkastele kampanjoita listanäkymässä.',
    'screens.header.image': 'Kuva',
    'screens.header.title': 'Nimi',
    'screens.header.zone': 'Alue',
    'screens.header.tags': 'Tagit',
    'screens.header.preview_loop': 'Esikatselu silmukka',
    'screens.header.capacity': 'Aikaa jäljellä kaupan osuudesta',
    'screens.button.map_view': 'Kartta',
    'screens.button.list_view': 'Lista',
    'screens.capacity.status':
      '%{secondsLeft} jäljellä %{maxLoopLength} sekunnista',
    'screens.capacity.timestamp': 'Last updated %{timestamp}',

    // SCREEN
    'screen.button.central_content': 'Keskitetyt kampanjat',
    'screen.button.local_content': 'Omat kampanjat',
    'screen.header.media': 'Media',
    'screen.header.name': 'Nimi',
    'screen.header.start_date': 'Alkamispäivä',
    'screen.header.end_date': 'Päättymispäivä',
    'screen.header.edit': 'Muokkaa',
    'screen.header.like': 'Tykkää',
    'screen.header.delete': 'Poista',
    'screen.header.disconnect': 'Kytke pois päältä',
    'screen.header.booking': 'Varaus',
    'screen.button.add_existing_ad': 'Lisää olemassa oleva kampanja',
    'screen.button.create_new_ad': 'Luo uusi kampanja',
    'screen.button.edit': 'Muokkaa',
    'screen.button.remove': 'Poista',
    'screen.button.remove.confirm': 'Poista',
    'screen.link.download_media':
      'Klikkaa hiiren kakkospainikkeella ja valitse "Tallenna nimellä" ladataksesi median.',

    // PLAYER FORM
    'playerform.button.save': 'Tallenna',
    'playerform.button.cancel': 'Peruuta',
    'playerform.feedback.saved': 'Tallennettu',

    // MY MEDIA
    'file.button.add_media': 'Lataa uusi',
    'file.header.media': 'Media',
    'file.header.name': 'Nimi',
    'file.header.format': 'Formaatti',
    'file.header.length': 'Pituus',
    'file.header.date_added': 'Lisätty',
    'file.header.delete': 'Poista',
    'file.button.remove': 'Poista',
    'file.button.remove.confirm': 'Poista?',
    'file.upload.message':
      'Lataa tiedostot pudottamalla ne tänne tai klikkaamalla valitaksesi.',

    // TEMPLATES
    'htmlad_template.header.thumbnail': 'Media',
    'htmlad_template.header.title': 'Nimi',
    'htmlad_template.header.profile': 'Profiili',
    'htmlad_template.header.category': 'Kategoria',
    'htmlad_template.header.format': 'Formaatti',
    'htmlad_template.header.date_added': 'Lisätty',
    'htmlad_template.header.action': 'Toiminto',
    'htmlad_template.header.current': 'Ajankohtaiset',
    'htmlad_template.header.popular': 'Suosituimmat',
    'htmlad_template.header.favorite': 'Omat suosikit',
    'htmlad_template.button.choose': 'Valitse',
    'htmlad_template.infotext1':
      'Valitse sopiva kampanjapohja kampanjallesi. Voit suodattaa kampanjapohja-valikoimaa formaattikohtaisesti ja sen mukaan millä osastoilla niitä esittää. Lisäksi voit käyttää hauka, jos tiedät kampanjapohjan nimen tai osan siitä.',
    'htmlad_template.infotext2_1':
      'Voit lajitella kampanjapohjia seuraavilla valinnoilla:',
    'htmlad_template.infotext2_2':
      'Sivun oletusjärjestys lajittelee kampanjapohjat <b>Ajankohtaiset</b> -valinnan mukaan, joka näyttää ensimmäisinä sesonkikohtaiset ja tarjouspohjat.',
    'htmlad_template.infotext2_3':
      'Lajittelemalla <b>Suosituimmat</b> -mukaan näet ensimmäisinä suosituimmat kampanjapohjat Keskon kaupoissa.',
    'htmlad_template.infotext3':
      '<b>Omat suosikit</b> - Voit valita omat suosikkipohjasi klikkaamalla sydän-symbolia niiden kohdalla. Voit järjestellä kampanjapohjat omien sousikkiesi mukaan tämän jälkeen käyttämällä "Omat suosikit"-lajittelua',
    'htmlad_template.tooltip.favorite': 'Favorite',
    'htmlad_template.tooltip.save_as_favorite': 'Save as favorite',

    'ad_form_template.infotext':
      'Tämä kampanjapohja täydentää tuotekentät Keskon taustajärjestelmistä saatavilla olevilla tiedoilla, jos kampanjapohjaa käyttää EAN- koodilla. Osa kampanjapohjan kentistä on lukittu muokkaamiselta ja osaa pystyy itse muokkaamaan.<br/><br/>EAN - koodia käyttäessä kaikki tuotetietokentät ovat lähtökohtaisesti yhdistettynä Keskon taustajärjestelmiin sieltä tulevien päivitysten varalta. Yhteys Keskon taustajärjestelmiin kuitenkin katkeaa kentästä, jos kyseistä kenttää muokkaa. Tällöin päivitys tuotetietoihin täytyy tehdä itse. Kentät saa takaisin yhdistetty - tilaan tyhjentämällä kampanjapohjan, ja hakemalla tuotetiedot uudestaan.',
    'ad_form_template.connected_infotext':
      'Yhdistetty Keskon taustajärjestelmiin',
    'ad_form_template.will_disconnect_infotext':
      'Yhteys Keskon taustajärjestelmiin poistuu',
    'ad_form_template.disconnected_infotext':
      'Ei yhteyttä Keskon taustajärjestelmiin',
    'ad_form_template.connected_box_text': 'Yhdistetty',
    'ad_form_template.will_disconnect_box_text': 'Yhdistetty',
    'ad_form_template.disconnected_box_text': 'Ei yhdistetty',

    // MY ADS
    'my_ads.button.create_new': 'Luo uusi kampanja',
    'my_ads.button.back': 'Takaisin',
    'my_ads.header.image': 'Kuva',
    'my_ads.header.name': 'Nimi',
    'my_ads.header.acr_type': 'Sisältötyyppi',
    'my_ads.header.start_date': 'Aloituspäivämäärä',
    'my_ads.header.end_date': 'Päättymispäivä',
    'my_ads.header.edit': 'Muokkaa',
    'my_ads.header.delete': 'Poista',
    'my_ads.header.add': 'Lisää',
    'my_ads.button.edit': 'Muokkaa',
    'my_ads.header.zones': 'Alue',
    'my_ads.button.remove': 'Poista',
    'my_ads.button.remove.confirm': 'Poista?',
    'my_ads.button.add': 'Lisää',
    'my_ads.button.archive': 'Arkistoi',
    'my_ads.button.unarchive': 'Palauta',
    'my_ads.button.unarchive_campaigns': 'Palauta luonnokseksi',
    'my_ads.modal.archive.title': 'Arkistoi kampanjat?',
    'my_ads.modal.archive.body':
      'Oletko varma, että haluat arkistoida valitut kampanjat?',
    'my_ads.modal.unarchive.title': 'Palauta kampanjat luonnoksiksi?',
    'my_ads.modal.unarchive.body':
      'Oletko varma, että haluat palauttaa valitut kampanjat luonnoksiksi?',
    my_ads: {
      all: 'Kaikki',
      draft: 'Luonnos/tauolla',
      ongoing: 'Käynnissä olevat',
      upcoming: 'Tulevat',
      ended: 'Päättyneet',
      archive: 'Arkisto',
      information_text: {
        all: '',
        draft: '',
        ongoing: '',
        upcoming: '',
        ended:
          '<p>Kampanjat siirtyvät arkistoon 60 päivää kampanjan päättymisen jälkeen. Siirrä kampanja jo ennen arkistoon siirtymistä takaisin luonnokseksi avaamalla kampanja ja muuttamalla sen tila luonnokseksi, jos tiedät kampanjalle olevan tarvetta jatkossakin joko sellaisenaan tai kopioitavana pohjana uusia kampanjoita tehdessä. Arkistoon siirtyneet kampanjat poistetaan järjestelmästä kaksi vuotta arkistoon siirtymisen jälkeen.</p>',
        archived:
          '<p>Älä käytä arkistoa varastona kampanjoille, joita haluat käyttää jatkossa uudelleen. Palauta ne arkistosta luonnokseksi valitsemalla yksi tai useampi kampanja ja valitse Palauta luonnokseksi. Kaksi vuotta arkistossa olleet kampanjat poistetaan automaattisesti.</p>',
      },
      search: {
        zones: 'Valitse alue',
        screen: 'Valitse näyttö',
        booking_type: 'Sisältötyyppi',
        text: 'Haku'
      },
    },
    'my_ads.button.play': 'Toista kampanjat',
    'my_ads.button.pause': 'Tauota kampanjat',
    'my_ads.playing_now': 'Käynnissä',
    'my_ads.playing_when_scheduled': 'Tuleva',
    'my_ads.paused_now': 'Tauotettu',
    'my_ads.paused_when_scheduled': 'Tuleva - Tauotettu',

    // FORM FIELDS
    'formfield.media.upload_text': 'Pudota mediatiedostosi tähän',
    'formfield.media.browse': 'Lataa',
    'formfield.media.browse_library': 'Oma mediakirjasto',
    'formfield.image.upload_text': 'Pudota kuva tähän',
    'formfield.image.browse': 'Lataa',
    'formfield.image.browse_library': 'Oma mediakirjasto',
    'image.button.pick': 'Valitse',
    'formfield.video.upload_text': 'Pudota video tähän (mp4, mov)',
    'formfield.video.browse': 'Valitse',
    'formfield.switch.selectall': 'Valitse kaikki',
    'formfield.switch.deselectall': 'Poista valinnat',
    'formfield.switch.availability_text': 'Viereiset palkit kertovat näytöltä teille varatun aikaosuuden tilanteen. Punainen väri tarkoittaa, että näytöltä teille varattu aikaosuus on täynnä, ja sisällöt tulevat näkymään näytöllä harvemmin. Poistamalla vanhoja tai tarpeettomia sisältöjä voit vapauttaa aikaosuutta uudelle materiaalille.',
    'formfield.rtftextarea.add_link': 'Lisää Linkki',

    // FORM FIELDS MODALS
    'formfield.rtftextarea.modal.create_link.title': 'Lisää linkii',
    'formfield.rtftextarea.modal.create_link.cancel': 'Peruuta',
    'formfield.rtftextarea.modal.create_link.save': 'Lisää linkii',
    'formfield.rtftextarea.modal.create_link.display_text': 'Näytettävä teksti',
    'formfield.rtftextarea.modal.create_link.display_text.placeholder': 'Esim: Kesko',
    'formfield.rtftextarea.modal.create_link.webaddress': 'Osoite',
    'formfield.rtftextarea.modal.create_link.webaddress.placeholder': 'Esim: "http://kesko.fi"',

    // VIEW OPTIONS
    'view_options.label.select_week': 'Valitse viikko',

    // SEARCH
    'search_field.placeholder': 'Hae',
    'search_field.button.search': 'Haku',

    // EDIT
    'htmladform.feedback.saving_form': 'Tallennetaan ...',
    'htmladform.feedback.htmlad_saved': 'Kampanja on tallennettu!',
    'edit.header.ad_name': 'Kampanjan nimi',
    'edit.label.ad_name': 'Kampanjan nimi',
    'edit.placeholder.ad_name': 'Kampanjan nimi',
    'edit.button.edit': 'Muokkaa',
    'edit.button.play': 'Play',
    'edit.button.pause': 'Pause',
    'edit.button.preview': 'Esikatselu',
    'edit.button.schedule': 'Aikataulu',
    'edit.button.save': 'Tallenna',
    'edit.button.copy_ad.disabled':
      'Kampanja on tallennettava ennen kuin voit kopioida sen',
    'edit.button.copy_ad': 'Kopioi kampanja',

    // SCHEDULE
    'schedule.header.schedule': 'Aikataulu',
    'schedule.header.days': 'Viikonpäivä',
    'schedule.header.daypart': 'Päivänosa',
    'schedule.header.show_in_zones': 'Näytä alueilla:',
    'schedule.placeholder.start_date': 'Aloituspäivä',
    'schedule.placeholder.end_date': 'Päättymispäivä',
    'schedule.placeholder.start_time': 'Aloitusaika',
    'schedule.placeholder.end_time': 'Päättymisaika',

    // EAN FORM
    'htmlad_ean_code_form.button.choose': 'Käytä EAN-koodia',
    'htmlad_ean_code_form.button.scan': 'Scan EAN-koodia',
    'htmlad_ean_code_form.button.clear': 'Avaa ja tyhjennä',
    'htmlad_ean_code_form.check.content': 'Hae tuotetiedot EAN-koodilla',
    'htmlad_ean_code_form.check.price': 'Hae paikallinen hinta EAN-koodilla',
    'htmlad_ean_code_form.input.placeholder': 'EAN-koodi',

    // PREVIEW
    'htmlad_player.tooltip.replay': 'toista',
    'htmlad_player.tooltip.toggle_size': 'zoomaa',
    'htmlad_player.tooltip.close_player': 'sulje esikatselu',

    // MEDIA
    'media.search_form.placeholder.search_media': 'Hae media',
    'media.search_form.button.search': 'Haku',
    'media.button.central_images': 'Kuvat',
    'media.button.central_movies': 'Videot',
    'media.button.local_media': 'Paikallinen',
    'media.header.media': 'media',
    'media.header.name': 'Nimi',
    'media.link.close': 'Sulje',
    'media.link.select': 'Valitse',
    'media.link.delete': 'Poista',

    // MEDIA PICKER
    'mediapicker.modal.header': 'Valitse media',
    'mediapicker.header.name': 'Nimi',
    'mediapicker.endpoint.images': 'mediakirjasto',
    'mediapicker.endpoint.files': 'Video',
    'mediapicker.endpoint.local_media': 'Oma media',
    'mediapicker.modal.show_format': 'Näytä muoto',

    // settings
    'settingsform.button.save': 'Tallenna',
    'settingsform.feedback.settings_saved': 'Asetukset tallennettu',

    // WEEKLY OFFERS
    'campaigns.central_campaign.infotext1':
      'Täällä voit seurata myymälässä käynnissä olevia tai tulevia keskitetysti ohjattuja kampanjoita. Listasta näet kampanjan aineiston, nimen, alueen jolla se näytetään kaupassa ja kampanja-ajan. Voit suodattaa kampanjalistaa alueittain Valitse alue-valikosta tai hakea kampanjoita nimen perusteella hakutoiminnolla. Voit myös valita näytettäväksi vain käynnissä olevat kampanjat tai tulevat kampanjat.',
    'campaigns.central_campaign.infotext2':
      'Voit esikatsella kampanjoiden aineistoja klikkaamalla niiden silmäikonin kohdalta. Voit tauottaa keskitetyn kampanjan klikkaamalla “Käynnissä” tai “Tuleva - Tauotettu”-ikoneita, jonka jälkeen päätät kuinka kauan kampanja pysyy tauotettuna. Voit valita useampia kampanjoita kerralla tauotettaviksi tai poistaa tauotuksen niistä valitsemalla kampanjat listan vasemmasta laidasta ja sen jälkeen valitsemalla “Poista tauotus” tai “Tauota kampanjat” listan oikeasta yläreunasta.',
    'campaigns.central_campaign.playing_now': 'Käynnissä',
    'campaigns.central_campaign.paused_now': 'Tauotettu',
    'campaigns.central_campaign.upcoming_will_play': 'Tuleva',
    'campaigns.central_campaign.upcoming_will_be_paused': 'Tuleva - Tauotettu',

    // CAMPAIGN TABS
    'campaigns.all': 'Kaikki',
    'campaigns.ongoing': 'Käynnissä olevat',
    'campaigns.draft': 'Tauolla',
    'campaigns.upcoming': 'Tulevat',

    'campaigns.central_campaign.play_ad_modal.titel': 'Aktivoi kampanja?',
    'campaigns.central_campaign.play_ad_modal.text1':
      'Haluatko varmasti aktivoida valitun tai valitut kampanjan? Alkanut kampanja käynnistyy tällöin uudelleen ja tuleva kampanja alkamispäivänään.',
    'campaigns.central_campaign.play_ads_modal.titel': 'Aktivoi kampanjat?',
    'campaigns.central_campaign.play_ads_modal.text1':
      'Haluatko varmasti aktivoida valitun tai valitut kampanjat? Alkanut kampanja käynnistyy tällöin uudelleen ja tuleva kampanja alkamispäivänään.',
    'campaigns.central_campaign.play_ad_modal.text2':
      'Tässä saattaa kestää hetki.',
    'campaigns.central_campaign.play_ad_modal.cancel': 'Peruuta',
    'campaigns.central_campaign.play_ad_modal.play': 'Aktivoi',

    'campaigns.central_campaign.pause_ad_modal.titel': 'Tauota kampanja?',
    'campaigns.central_campaign.pause_ad_modal.text1':
      'Haluatko varmasti tauottaa tämän kampanjan?',
    'campaigns.central_campaign.pause_ad_modal.text2':
      'Valitse kampanjan tauon kesto',
    'campaigns.central_campaign.pause_ad_modal.text3':
      'Tässä saattaa kestää hetki.',
    'campaigns.central_campaign.pause_ads_modal.titel': 'Tauota kampanjat?',
    'campaigns.central_campaign.pause_ads_modal.text1':
      'Haluatko varmasti tauottaa valitut kampanjat?',
    'campaigns.central_campaign.pause_ads_modal.text2':
      'Valitse valittujen kampanjoiden tauon kesto',
    'campaigns.central_campaign.pause_ad_modal.cancel': 'Peruuta',
    'campaigns.central_campaign.pause_ad_modal.pause': 'Tauota',
    'campaigns.central_campaign.pause_ad_modal.error-text':
      'Et voi valita kuluvaa päivää aikaisempaa päivää',

    'campaigns.local_campaign.infotext1':
      'Tällä sivulla näet kaikki kaupan osmat paikalliset kampanjat. Voit esikatsella videoita, määritä millä alueilla videoiden tulisi näkyä, muokata kampanjasisältöä ja käynnistää kampanjan.',
    'campaigns.local_campaign.infotext2':
      'Jos haluat näyttää kampanjan ehdotetulla näytöllä tai vyöhykkeellä, esikatsele kampanja ensin kampanjakuvakkeesta ja sitten klikkaa vasemmalla olevaa valintaruutua. Jos haluat muokata millä näytöillä tai vyöhykkeillä kampanja tulee näyttää tai haluat muuttaa infotekstiä tai kuvaa, klikkaa oikealla olevaa kynä-ikonia ja tee muutokset.',
    'campaigns.local_campaign.infotext3': '',
    'campaigns.local_campaign.infotext4':
      'Alueet on määritelty tavararyhmien perusteella. Kaupassa voi olla yksi tai useampi näyttö kyseisellä alueella. ',
    'campaigns.local_campaign.infotext5':
      'Voit suodattaa kampanjoita alkamis- tai päättymispäivän, alueen tai vapaan sanahaun avulla.',
    'campaigns.local_campaign.infotext6':
      'In the filter above the list of all offers, you can filter by start and end dates, which screens they are selected to play on or search freely for a specific offer.',
    'campaigns.central_offers': 'Keskitetyt kampanjat',
    'campaigns.my_offers': 'Omat kampanjat',
    'campaigns.start_end_date': 'Aloitus- ja päättymispäivämäärät',
    'campaigns.active_zones': 'Valitse alue',
    'campaigns.search_campaign': 'Haku',
    'campaigns.header.title': 'Kampanja',
    'campaigns.header.zones': 'Alue',
    'campaigns.header.broadcast_status': 'Status',
    'campaigns.header.status': 'Tila',
    'campaigns.header.edit': 'Muokkaa',
    'campaigns.header.playing_now': 'Playing now',
    'campaigns.header.playing_when_scheduled': 'Playing when scheduled',
    'campaigns.header.paused_now': 'Paused now',
    'campaigns.header.paused_when_scheduled': 'Paused when scheduled',
    'campaigns.header.locations_chosen': 'Valitut kampanjat',
    'campaigns.header.play_ads': 'Toista kampanjat',
    'campaigns.header.pause_ads': 'Tauota kampanjat',
    'campaigns.header.add_zones': 'Lisää alue',
    'campaigns.header.remove_zones': 'Poista alue',
    'campaigns.item.paused_until': 'until',
    'campaigns.item.ends': 'Loppuu',
    'campaigns.item.starts': 'Alkaa',
    'campaigns.item.paused': 'Tauolla',
    'campaigns.item.until': 'asti',

    'campaigns.modal.addzones.header':
      'Määritä kampanjoiden sijainti myymälässä',
    'campaigns.modal.addzones.body1':
      'Valitse kaikki alueet, joilla haluat näyttää sisältöä. Voit valita yhden tai useamman alueen tai kaikki alueet valitsemalla "Näytä kaikilla alueilla".',
    'campaigns.modal.addzones.body2':
      'Vähintään yksi alue on valittava, jotta voit tallentaa asetukset.',
    'campaigns.modal.addzones.select_all_checkbox': 'Näytä kaikilla alueilla',
    'campaigns.modal.removezones.header': 'Piilota kampanjoita myymälästä',
    'campaigns.modal.removezones.body1':
      'Valitse kaikki alueet, joilta haluat piilottaa sisältä. Voit valita yhden tai useamman alueen tai kaikki alueet valitsemalla "Piilota kaikilta alueilta".',
    'campaigns.modal.removezones.body2':
      'Vähintään yksi alue on valittava, jotta voit tallentaa asetukset.',
    'campaigns.modal.removezones.select_all_checkbox':
      'Piilota kaikilta alueilta',
    'campaigns.modal.playselected.header':
      'Haluatko toistaa valitut kampanjat?',
    'campaigns.modal.playselected.body1':
      'Klikkaa toistopainiketta, jos haluat haluat toistaa kaikki valitsemasi kampanjat.',
    'campaigns.modal.playselected.body2':
      'Toistetaan vain kampanjat, joissa on valitut vyöhykkeet.',
    'campaigns.modal.pauseselected.header':
      'Haluatko keskeyttää valitut kampanjat?',
    'campaigns.modal.pauseselected.body1':
      'Klikka taukopainiketta, jos haluat, että kaikki valitsemasi kampanjat keskeytetään.',

    // Content recommendations
    'content_recommendations.store': 'Kauppa',
    'content_recommendations.tactical_offers': 'Tarjoukset',
    'content_recommendations.marketing': 'Asiakasviestintä',
    'content_recommendations.additional_marketing': 'Muu asiakasviestintä',
    'content_recommendations.infotext1': 'Täällä näet erilaisia suosituksia kampanjoista julkaistavaksi markkinointinäytöille. Sisältöä voi julkaista valitsemalla yhden tai useita yksittäisiä kampanjoita. Vaihtoehtoisesti sisältötyypin kaikille kampanjoille voi käynnistää automaattisen julkaisun. Automaattisen julkaisun asetuksista voit määrittää alueet tai näytöt, jolle sisältöä ei haluta julkaista automaattisesti. Julkaistut kampanjat kopioituvat Omat kampanjat ja pohjat - osioon.',
    'content_recommendations.infotext2': 'Erilaiset sisältötyypit on listattu omiin osioihinsa. Voit lisäksi tarkastella omilla välilehdillä käynnissä olevia, tulevia tai kaikkia kampanjoita. Listasta näet kampanjan aineiston, nimen, sisältötyypin, alueen jolla se näytetään kaupassa sekä kampanja-ajan. Sisältötyypistä riippuen kampanjoita voi muokata vaihtelevasti. Kaikkien kampanjoiden kohdistusta näytöille voi kuitenkin aina muuttaa. Voit suodattaa kampanjalistaa alueittain Valitse alue -valikosta tai hakea kampanjoita nimen perusteella hakutoiminnolla.',

    'content_recommendations.all': 'Kaikki',
    'content_recommendations.ongoing': 'Käynnissä olevat',
    'content_recommendations.draft': 'Tauolla',
    'content_recommendations.upcoming': 'Tulevat',

    'content_recommendations.header.title': 'Kampanja',
    'content_recommendations.header.acr_type': 'Sisältötyyppi',
    'content_recommendations.header.zones': 'Alue',
    'content_recommendations.header.edit': 'Muokkaa',
    'content_recommendations.header.status': 'Tila',
    'content_recommendations.header.ads_chosen': 'Valitut kampanjat',
    'content_recommendations.header.play_ads': 'Julkaise kampanjat',
    'content_recommendations.header.pause_ads': 'Tauota kampanjat',
    'content_recommendations.active_zones': 'Valitse alue',
    'content_recommendations.search_campaign': 'Haku',

    'content_recommendations.item.ends': 'Loppuu',
    'content_recommendations.item.starts': 'Alkaa',
    'content_recommendations.item.paused': 'Tauolla',
    'content_recommendations.item.until': 'asti',

    // Auto-publish modal
    'content_recommendations.button.activate_auto_publish': 'Julkaise automaattisesti',
    'content_recommendations.auto_publish_modal.activate.title': 'Julkaise automaattisesti',
    'content_recommendations.auto_publish_modal.activate.text': 'Haluatko varmasti asettaa automaattisen julkaisun kaikille tarjouksille?',
    'content_recommendations.auto_publish_modal.activate.text2': 'Kampanjat kopiodaan Omat kampanjat ja pohjat - osioon ja julkaistaan. Voit halutessasi muokata ja tauotta julkaistuja kampanjoita.',
    'content_recommendations.auto_publish_modal.activate.confirm': 'Kyllä',
    'content_recommendations.auto_publish_modal.activate.cancel': 'En',
    'content_recommendations.button.deactivate_auto_publish': 'Lopeta automaattinen julkaisu',
    'content_recommendations.auto_publish_modal.deactivate.title': 'Lopeta automaattinen julkaisu',
    'content_recommendations.auto_publish_modal.deactivate.text': 'Tämä poistaa automaattisen julkaisun käytöstä tulevilta Tarjous-kampanjoilta. Jo julkaistut kampanjat näkyvät näytöillä päättymispäivään saakka.',
    'content_recommendations.auto_publish_modal.deactivate.confirm': 'Lopeta automaattinen julkaisu',
    'content_recommendations.auto_publish_modal.deactivate.cancel': 'Peruuta',

    // Auto-publish-settings modal
    'content_recommendations.auto_publish_settings_modal.title': 'Automaattisen julkaisun asetukset',
    'content_recommendations.auto_publish_settings_modal.text1': 'Kampanjoita suositellaan vaihtelevasti kaikille Keskon konseptiin kuuluville näytöille. Voit halutessasi rajata pois alueet tai näytöt, joille et halua julkaista suositeltuja kampanjoita automaattisesti.',
    'content_recommendations.auto_publish_settings_modal.text2': 'Voit siirtyä näyttö - ja aluevalikoiden välillä poistamalla ensin kaikki valinnat.',
    'content_recommendations.auto_publish_settings_modal.text3': 'Sisältöjä voidaan julkaista valituille alueille tai näytöille:',
    'content_recommendations.auto_publish_settings_modal.cancel': 'Peruuta',
    'content_recommendations.auto_publish_settings_modal.confirm': 'Tallenna',

    // Play modal
    'content_recommendations.play_modal.title': 'Julkaise valitut',
    'content_recommendations.play_modal.confirm': 'Julkaise',
    'content_recommendations.play_modal.cancel': 'Peruuta',
    'content_recommendations.play_modal.text': 'Valitut kampanjat kopioidaan Omat kampanjat ja pohjat -osioon ja julkaistaan. Voit halutessasi muokata julkaistua kampanjaa ja keskeyttää sen.',
    'content_recommendations.play_multiple_modal.text': 'Valitut kampanjat kopioidaan Omat kampanjat ja pohjat - osioon ja julkaistaan. Voit halutessasi muokata ja tauottaa julkaistuja kampanjoita.',

    // Pause modal
    'content_recommendations.pause_modal.title': 'Tauota kampanjat',
    'content_recommendations.pause_modal.confirm': 'Tauota',
    'content_recommendations.pause_modal.cancel': 'Peruuta',
    'content_recommendations.pause_modal.text': 'Haluatko varmasti tauottaa tämän kampanjan? Tässä saattaa kestää hetki.',
    'content_recommendations.pause_multiple_modal.text': 'Haluatko varmasti keskeyttää nämä tarjoukset? Tämä voi kestää hetken.',

    // Icon hover texts
    'content_recommendations.item.playing_now': 'Käynnissä',
    'content_recommendations.item.playing_when_scheduled': 'Tuleva',
    'content_recommendations.item.paused_now': 'Tauotettu',
    'content_recommendations.item.paused_when_scheduled': 'Tuleva - Tauotettu',

    // modals
    'modal.button.close': 'sulje',
    'modal.tooltip.close': 'sulje',

    'modal.button.confirm': 'OK',
    'modal.button.cancel': 'Kumoa',
    'modal.button.copy': 'Kopioi',
    'modal.button.delete': 'Poista',
    'modal.button.schedule': 'Aikataulu',
    'modal.button.play': 'Play',
    'modal.button.pause': 'Pause',

    'modal.header.delete': 'Haluatko varmasti poistaa?',
    'modal.header.delete_media':
      'Oletko varma? Kampanjoissa käytettyjen mediatiedostojen poistaminen voi aiheuttaa virheitä. ',

    'modal.header.add_to_homescreen': 'Lisää sovelllus aloitusnäyttöön',
    'modal.text.add_to_homescreen':
      'Klikkaa valikkokuvaketta ja valitse "Lisää aloitusnäyttöön", jotta sovellukseen pääsee helposti ',

    'modal.header.ad_saved': 'Kampanja on tallennettu',
    'modal.text.ad_saved': 'Kampanjasi on nyt tallennettu.',

    'modal.header.schedule_ad': 'Kampanja on tallennettu, mutta ei ajastettu.',
    'modal.text.schedule_ad':
      'Jotta kampanjaa voi näyttää, sinun on ajastettava se!',

    'modal.header.copy_ad': 'Kopioi kampanja',
    'modal.text.copy_ad':
      'Tämä luo uuden kampanjan, jolla on sama pohja, ajastus ja kanavat. Kaikki muutokset, joita et ole tallentanut, katoavat nykyisestä kampanjasta. Oletko varma? ',

    'modal.header.logged_out': 'Olet kirjautunut ulos',
    'modal.text.logged_out':
      'Kampanjaa ei tallenneta. Avaa uusi välilehti ja kirjaudu sisään uudelleen, tallenna sitten uudelleen. ',

    'modal.header.missing_fields': 'Kampanjaa ei tallennettu',
    'modal.text.missing_fields':
      'Varmista, että kaikki pakolliset kentät on täytetty ja että olet nimennyt kampanjan.',

    'modal.header.disconnect_ad_from_last_zone': 'Poistetaanko varaus?',
    'modal.text.disconnect_ad_from_last_zone':
      'Varaus ei sisällä muita alueita, haluatko poistaa varauksen?',
    'modal.header.disconnect_ads_from_last_zone': 'Poistetaanko varaukset?',
    'modal.text.disconnect_ads_from_last_zone':
      'Kaikki valitsemasi varauksen kampanjat poistetaan. Haluatko varmasti poistaa valitut varaukset? ',

    'modal.header.file_uploads': 'Ohjeet',
    'modal.text.file_uploads_image':
      '<h3> Kuva: </h3>' +
      'Suositeltu kuvan koko pystysuuntaisessa näytössä on 1080*1920 pikseliä <br>' +
      'Suositeltu kuvan koko vaakanäytölle on 1920*1080 pikseliä <br>' +
      'Älä lataa kuvia, jotka ovat pienempiä kuin 500*500 pikseliä <br>' +
      'Hyväksytyt kuvamuodot: JPEG ja PNG <br>' +
      'Enimmäiskoko: 100 Mt',
    'modal.text.file_uploads_video':
      '<h3> Video: </h3>' +
      'Suositeltu videon koko pystysuunnassa on 1080 * 1920 pikseliä <br>' +
      'Suositeltu videon koko vaakasuunnassa on 1920 * 1080 pikseliä <br>' +
      'Hyväksytyt videomuodot: MP4 ja MOV <br>' +
      'Suurin tiedostokoko: 100 Mt <br>' +
      'Suositeltu videon pituus: <10 sekuntia',

    'modal.header.duplicate_name': 'Nimi on jo käytössä',
    'modal.text.duplicate_name':
      'Olet jo tallentanut yhden kampanjan samalla nimellä. Käytä toista nimeä ja yritä uudelleen',

    'modal.header.map_zone_picker': 'Valitse myymälän alue',
    'modal.text.map_zone_picker':
      'Valitse millä alueella haluat nähdä sisällön.',

    //PREVIEW LOOP MODAL
    'previewmodal.header': 'Katso soittolista näytölle ',
    'previewmodal.body':
      'Katso soittolista näytölle ## valitsemallasi päivämäräällä ja ajalla. Huomaa että soittolistan esikatselussa kampanjoiden esittämiseen vaikuttaa kampanjoiden prioriteettitasot, toistosäännöt, sisältötyypin varausaste yms. säännöt.',
    'previewmodal.date': 'Päivämäärä:',
    'previewmodal.time': 'Aika:',
    'previewmodal.cancel': 'Peruuta',
    'previewmodal.view_loop': 'Näytä soittolista',
    'previewloop.nomedia':
      'Tietoja valitulta ajalta ei löydy, valitse uusi ajanjakso.',

    //VIEW LOOP MODAL
    'viewloopmodal.titel.minutes_and_seconds':
      'Soittolista näytöllä %{playerName} %{date} klo. %{time}.',
    'viewloopmodal.titel.seconds':
      'Soittolista näytöllä %{playerName} %{date} klo. %{time}.',
    'viewloopmodal.titel':
      'Soittolista näytöllä %{playerName} %{date} klo. %{time}.',
    'viewloopmodal.nomedia':
      'Tietoja valitulta ajalta ei löydy, valitse uusi ajanjakso.',

    // PAGINATION
    'pagination.button.view_all': 'Näytä kaikki',
    'pagination.button.view_pagination': 'Takaisin',

    // DAYS
    'All days': 'Kaikki päivät',
    Monday: 'Maanantai',
    Tuesday: 'Tiistai',
    Wednesday: 'Keskiviikko',
    Thursday: 'Torstai',
    Friday: 'Perjantai',
    Saturday: 'Lauantai',
    Sunday: 'Sunnuntai',

    // PIKADAY
    pikaday: {
      previousMonth: 'Edellinen kuukausi',
      nextMonth: 'Seuraava kuukausi',
      months: [
        'tammikuu',
        'helmikuu',
        'maaliskuu',
        'huhtikuu',
        'toukokuu',
        'kesäkuu',
        'heinäkuu',
        'elokuu',
        'syyskuu',
        'lokakuu',
        'marraskuu',
        'joulukuu',
      ],
      weekdays: [
        'sunnuntai',
        'maanantai',
        'tiistai',
        'keskiviikko',
        'torstai',
        'perjantai',
        'lauantai',
      ],
      weekdaysShort: ['su', 'ma', 'ti', 'ke', 'to', 'pe', 'la'],
    },

    // MISC
    date_format: 'YYYY-MM-DD',
    date_format_fi: 'DD.MM.YYYY',
    time_format: 'HH.mm',

    // ERROR
    'error.404.header': 'Virhe: 404',
    'error.404.description': 'Sivua ei löydy',
    'error.404.path': 'Polku',
    'error.file_upload_failed.header': 'Tiedoston lähetys epäonnistui',
    'error.file_upload_failed.message':
      'Tiedoston lataaminen epäonnistui. Yritä myöhemmin uudelleen. Tarkista myös ettei tiedostonimessä ole erikoismerkkejä ja vältä toistaiseksi tiedostojen lataamista iOS-laitteilla.',
    'error.unsaved_changes.header': 'Muutoksia tallentamatta',
    'error.unsaved_changes.message':
      'Sinulla on tallentamattomia muutoksia. Siirry eteenpäin painamalla Tallenna tai Peruuta. ',
    'error.general.ajax.header': 'Jokin meni pieleen',
    'error.general.header': 'Jokin meni pieleen',
    'error.general.message': 'Jokin meni pieleen, yritä uudelleen.',

    // SUCCESS
    success: {
      general: {
        header: 'Tiedot',
      },
    },

    // FORM SECTION
    'form_section.buttons.add': 'Lisää',
    'form_section.title.empty': 'Tyhjä',
  };
});

